
import { Component, Emit, Prop, Vue, State } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import TooltipButton from '@/components/ui/TooltipButton.vue';
import { Bookmark } from '@/store/userSettings.store';
import Link from '@/components/ui/toc/links/Link.ts';

@Component({
  components: { TooltipButton }
})
export default class BookmarkItem extends Vue {
  @Prop({ type: Object as PropType<Bookmark>, required: true })
  bookmark!: Bookmark;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.navigation[0] || [])
  navMain: Link;

  // @ts-ignore
  @State((state) => state.typo3?.initial?.site?.settings)
  settings;

  get link(): Link | null {
    const pid = this.bookmark.pageId;
    const queue = [];
    queue.push(this.navMain);
    let link: Link;
    const llink = {} as Link;
    Object.keys(this.settings).forEach((key) => {
      if (pid === this.settings[key]) {
        llink.title = this.$i18n.t('labels.static-pages.' + key) as string;
        llink.link = '?id=' + this.settings[key];
      }
    });

    while ((link = queue.pop())) {
      if (link && link.uid === pid) {
        return link;
      }
      if (link.children && link.children.length) {
        for (let i = 0; i < link.children.length; i++) {
          queue.push(link.children[i]);
        }
      }
    }
    return llink;
  }

  @Emit('delete-bookmark')
  deleteBookmark(): Bookmark {
    return this.bookmark;
  }

  @Emit('navigate-to-bookmark')
  navigateToBookmark(): Bookmark {
    return this.bookmark;
  }
}
